package br.com.texeratx.boardgametimeapp.ui.screens.matches

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.koin.compose.koinInject

class MatchesScreen : Screen {

    @Composable
    override fun Content() {
        val viewModel = koinInject<MatchesViewModel>()
        val state by viewModel.state.collectAsState()
        val navigator = LocalNavigator.currentOrThrow

        LaunchedEffect(Unit) {
            viewModel.loadMatches()
        }

        MatchesUI(
            state = state,
            onSearch = viewModel::onSearch,
            onApplyFilters = viewModel::updateFilters,
            onSortChange = viewModel::changeSort,
            onBack = { navigator.pop() },
            onDismissError = viewModel::dismissError
        )
    }
}
